ViewArticleController.$inject = ['ArticleService', '$stateParams']

export default function ViewArticleController(ArticleService, $stateParams) {
  var vm = this

  ArticleService.getArticle('61f8e43a79fd747201d0d3da', $stateParams.slug).then(res => vm.article = res.data)
}